import React from 'react';
import { type HeroQuotes } from '@bbkAdminUtils/api-client/rest-modals-cards-types';
import Quote from './quote';

type Props = {
  hero: HeroQuotes;
};
const ModalG2Quotes: React.FC<Props> = (props) => {
  const {
    hero: { quotes, title },
  } = props;

  const quoteBubbles = quotes.map((qt, index) => (
    <Quote info={qt} class={`quad${index + 1}`} key={`quad${index + 1}`} />
  ));

  return (
    <div className="modal-g2-quotes">
      <div className="MG2QContainer">
        {title && <div className="quotes-title">{title}</div>}
        <div className="quote-group">{quoteBubbles}</div>
      </div>
    </div>
  );
};

export default ModalG2Quotes;
